module.exports = __webpack_public_path__ + "img/logo.ce7755ea.png";